import config from 'config'

export default {
	ONBOARDING_ACTIVITY_EXPLAINER: `${config.www_cdn}assets/media/animations/onboarding/student-anim.json`,
	ONBOARDING_ACTIVITY_TRANSITION: `${config.www_cdn}assets/media/animations/onboarding/collaborate-creation-transition.json`,
	ONBOARDING_GRADES: `${config.www_cdn}assets/media/animations/onboarding/grades.json`,
	ONBOARDING_WELCOME: `${config.www_cdn}assets/media/animations/onboarding/welcome.json`,
	ONBOARDING_SUBJECTS: `${config.www_cdn}assets/media/animations/onboarding/subjects.json`,
	ONBOARDING_LOADING: `${config.www_cdn}assets/media/animations/onboarding/loading.json`,
	FIRST_LESSON_LOADING: `${config.www_cdn}assets/media/animations/dropped-is-loading.json`,
	FLOCABULARY_LIMIT_REACHED: `${config.www_cdn}assets/media/animations/flocabulary_limit_reached/flocabulary_limit_reached.json`,
	NICKET_TOUR_LESSON_INTERACTIVE: `${config.www_cdn}assets/media/animations/nickel_tour/lesson_interactive.json`,
	NICKET_TOUR_PRE_MADE_LESSONS: `${config.www_cdn}assets/media/animations/nickel_tour/pre_made_lessons.json`,
	NICKET_TOUR_REPORTS: `${config.www_cdn}assets/media/animations/nickel_tour/reports.json`,
	USER_SCHOOL_PROFILE_ANIMATED_SCHOOL: `${config.www_cdn}assets/media/animations/user_school_profile/animated_school.json`,
	DRAG_AND_DROP_ALL: `${config.www_cdn}assets/media/animations/drag_and_drop/all.json`,
	DRAG_AND_DROP_AUDIO: `${config.www_cdn}assets/media/animations/drag_and_drop/audio.json`,
	DRAG_AND_DROP_GIF: `${config.www_cdn}assets/media/animations/drag_and_drop/gif.json`,
	DRAG_AND_DROP_IMAGE: `${config.www_cdn}assets/media/animations/drag_and_drop/image.json`,
	DRAG_AND_DROP_PDF: `${config.www_cdn}assets/media/animations/drag_and_drop/pdf.json`,
	DRAG_AND_DROP_VIDEO: `${config.www_cdn}assets/media/animations/drag_and_drop/video.json`,
}
